import { render, staticRenderFns } from "./MainColumnOfPublicTender.vue?vue&type=template&id=14e2404e&scoped=true&"
import script from "./MainColumnOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./MainColumnOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./MainColumnOfPublicTender.vue?vue&type=style&index=0&id=14e2404e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e2404e",
  null
  
)

export default component.exports